import * as React from 'react';
import { AppBar, Layout, Sidebar, useNotify } from 'react-admin';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import CloudUploadOutlined from '@material-ui/icons/CloudUploadOutlined';
import AssessmentOutlined from '@material-ui/icons/AssessmentOutlined';
import { makeStyles } from '@material-ui/core/styles';
import * as XLSX from 'xlsx';
import { SCORE_URL } from '../BASE_CONSTS';

const readAsBase64Workbook = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Не удалось прочитать файл'));
    reader.onload = (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        resolve(XLSX.write(workbook, { bookType: 'xlsx', type: 'base64' }));
      } catch (error) {
        reject(error);
      }
    };
    reader.readAsArrayBuffer(file);
  });

const parseResponseError = async (response) => {
  try {
    const payload = await response.json();
    return payload.detail || payload.message || payload.error || `HTTP ${response.status}`;
  } catch (_error) {
    return `HTTP ${response.status}`;
  }
};

const XlsxImportButton = ({ endpoint, label, shortLabel, icon }) => {
  const notify = useNotify();
  const inputRef = React.useRef(null);
  const [loading, setLoading] = React.useState(false);

  const selectFile = () => {
    if (!loading && inputRef.current) inputRef.current.click();
  };

  const upload = async (event) => {
    const file = event.target.files && event.target.files[0];
    event.target.value = '';
    if (!file) return;

    setLoading(true);
    try {
      const base64 = await readAsBase64Workbook(file);
      const response = await fetch(`${String(SCORE_URL).replace(/\/+$/, '')}/${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ file: base64 }),
      });
      if (!response.ok) throw new Error(await parseResponseError(response));
      notify(`${label}: ${file.name} загружен`, 'info');
    } catch (error) {
      notify(`${label}: ${error.message}`, 'warning');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Tooltip title={label}>
        <Button
          className="fs-topbar-action"
          onClick={selectFile}
          disabled={loading}
          startIcon={icon}
          aria-label={label}
        >
          <span className="fs-topbar-action__full">{loading ? 'Загрузка…' : shortLabel}</span>
        </Button>
      </Tooltip>
      <input
        ref={inputRef}
        className="fs-visually-hidden"
        type="file"
        accept=".xlsx,.xls"
        onChange={upload}
      />
    </>
  );
};

export const FootSkillAppBar = (props) => (
  <AppBar {...props} container={React.Fragment} className="fs-topbar">
    <Typography variant="h6" color="inherit" className="fs-topbar-brand">
      FOOTSKILL <span>ADMIN</span>
    </Typography>
    <span className="fs-topbar-spacer" />
    <div className="fs-topbar-actions">
      <XlsxImportButton
        endpoint="xlsx/"
        label="Загрузка XLSX файла"
        shortLabel="Загрузить XLSX"
        icon={<CloudUploadOutlined />}
      />
      <XlsxImportButton
        endpoint="xlsx_phone/"
        label="Загрузка файла с баллами"
        shortLabel="Загрузить баллы"
        icon={<AssessmentOutlined />}
      />
    </div>
  </AppBar>
);

const useSidebarStyles = makeStyles({
  root: {
    height: 'auto !important',
  },
  drawerPaper: {
    backgroundColor: '#2D2D2E',
    color: '#FFFFFF',
    borderRight: 0,
    boxShadow: 'none',
  },
});

export const FootSkillSidebar = (props) => {
  const classes = useSidebarStyles();
  return <Sidebar {...props} classes={classes} />;
};

export const FootSkillLayout = (props) => (
  <Layout {...props} appBar={FootSkillAppBar} sidebar={FootSkillSidebar} />
);
